import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// import getBlockElementByKey from 'ada-core/src/components/Editor/utils/getBlockElementByKey';
import { observer } from 'mobx-react';
import { goToAnchor } from 'react-scrollable-anchor';
import { withStyles } from '@material-ui/core/styles';
import store from './store';
import ArrowDownIcon from '../../../../shared/icons/ArrowDown';
import ArrowUpIcon from '../../../../shared/icons/ArrowUp';

const styles = theme => ({
  collapsible: {},
  header: {
    cursor: 'pointer',
    textAlign: 'left',
    borderBottom: `1px solid ${theme.editorPalette.primary.main}`,
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)',
  },
});

// import style from './style.scss';

const getBlockElementByKey = key =>
  document.querySelector(`[data-offset-key^="${key}"][data-block="true"]`);

const hideAllBlocks = contentState => {
  contentState.blockMap.filter(block => {
    if (
      block.getType() === 'title' ||
      block.getType() === 'header-two' ||
      block.getType() === 'header-one'
    )
      return false;
    const key = block.getKey();
    const elem = getBlockElementByKey(key);

    const elemIsHidden = elem && elem.style.display === 'none';
    if (!elemIsHidden && elem) {
      elem.style.display = 'none';
    }
  });
  contentState.blockMap.filter(block => {
    const key = block.getKey();
    const elem = getBlockElementByKey(key);
    if (
      block.getType() === 'header-one' &&
      elem &&
      elem.nextSibling.nodeName === 'FIGURE'
    ) {
      elem.nextSibling.style.display = 'block';
    }
  });
};

const showAllBlocks = contentState => {
  contentState.blockMap.map(block => {
    if (
      block.getType() === 'title' ||
      block.getType() === 'header-two' ||
      block.getType() === 'header-one'
    )
      return false;
    const key = block.getKey();
    const elem = getBlockElementByKey(key);
    const elemIsHidden = elem && elem.style.display === 'none';
    if (elemIsHidden && elem) {
      elem.style.display = 'block';
    }
  });
};

const createCollapsible = editorProps => {
  @withStyles(styles)
  @observer
  class Collapsible extends React.Component {
    static defaultProps = {
      children: null,
      decoratedText: '',
    };

    static propTypes = {
      children: PropTypes.any,
      decoratedText: PropTypes.string,
      contentState: PropTypes.object.isRequired,
      offsetKey: PropTypes.string.isRequired,
    };

    get isPluginActive() {
      return editorProps.getReadOnly() && editorProps.getPage().type === 'faq';
    }

    // componentDidMount() {
    //   console.log('mount', this.contentState.getFirstBlock().getKey(), this.blockKey());
    //   if (this.contentState.getFirstBlock().getKey() !== this.blockKey())
    //     return;
    //   if (!this.isPluginActive) {
    //     showAllBlocks(this.contentState);
    //   } else {
    //     hideAllBlocks(this.contentState);
    //   }
    // }

    blockKey = () => { //eslint-disable-line
      return this.props.offsetKey.split('-')[0];
    };

    blockType = () => { //eslint-disable-line
      let key = this.blockKey();
      if (key.indexOf('-') > -1) key = key.split('-')[0];
      return this.props.contentState.getBlockForKey(key).getType();
    };

    get contentState() {
      return this.props.contentState;
    }

    findOpenBlocks = key => {
      const openBlocks = [];
      let block = this.contentState.getBlockAfter(key);
      while (block && block.getType() !== 'header-two') {
        openBlocks.push(block.getKey());
        block = this.contentState.getBlockAfter(block.getKey());
      }
      store.openBlocks = openBlocks;
    };

    handleActivate = () => {
      if (this.blockType() === 'header-two') {
        hideAllBlocks(this.contentState);
        store.activeBlock = this.blockKey();
        this.findOpenBlocks(this.blockKey());
        store.openBlocks.forEach(key => {
          const elem = getBlockElementByKey(key);
          const elemIsHidden = elem.style.display === 'none';
          if (elemIsHidden) {
            elem.style.display = 'block';
          }
        });
      }
    };

    renderIcon = () => {
      const { classes } = this.props;
      if (this.blockType() !== 'header-two') return null;
      return this.blockKey() === store.activeBlock ? (
        <ArrowDownIcon className={classes.icon} />
      ) : (
        <ArrowUpIcon className={classes.icon} />
      );
    };

    render() {
      const { children, classes } = this.props;
      if (!this.isPluginActive) {
        return <span>{children}</span>;
      }
      return (
        <div
          className={cx(classes.collapsible, {
            [classes.header]: this.blockType() === 'header-two',
          })}
          onClick={this.handleActivate}
        >
          {children}
          {this.renderIcon()}
        </div>
      );
    }
  }
  return Collapsible;
};

const createPlugin = () => {
  const editorProps = {
    getReadOnly: undefined,
    getPage: undefined,
  };
  const CollapsibleDec = createCollapsible(editorProps);
  return {
    initialize: ({ getProps, getEditorState }) => {
      editorProps.getReadOnly = () => getProps().readOnly;
      editorProps.getPage = () => getProps().page;
      const contentState = getEditorState().getCurrentContent();
      if (
        global.document &&
        getProps().readOnly &&
        getProps().page.type === 'faq'
      ) {
        setTimeout(() => {
          hideAllBlocks(contentState);
        }, 1);
        // setTimeout(() => {
        //   goToAnchor(location.hash, true);
        // }, 5000)
      }
    },
    decorators: [
      {
        strategy: (contentBlock, callback) => {
          callback(0, contentBlock.getText().length);
        },
        component: CollapsibleDec,
      },
    ],
  };
};

export default createPlugin;
